import type { Database } from '@hvf/contracts'

export type VideoProvider = Database['public']['Enums']['video_providers']

export interface DetectedVideo {
	provider: VideoProvider
	providerId: string
}

const YOUTUBE_PATTERNS = [
	/(?:youtube\.com\/watch\?(?:.*&)?v=|youtube\.com\/embed\/|youtube\.com\/shorts\/|youtu\.be\/)([a-zA-Z0-9_-]{6,})/,
]

const VIMEO_PATTERN = /vimeo\.com\/(?:video\/)?(\d+)/

const DAILYMOTION_PATTERNS = [
	/dailymotion\.com\/(?:embed\/)?video\/([a-zA-Z0-9]+)/,
	/dai\.ly\/([a-zA-Z0-9]+)/,
]

export function detectVideoFromUrl(url: string): DetectedVideo | null {
	const trimmed = url.trim()
	if (!trimmed) return null

	for (const pattern of YOUTUBE_PATTERNS) {
		const match = trimmed.match(pattern)
		if (match) return { provider: 'youtube', providerId: match[1] }
	}

	const vimeoMatch = trimmed.match(VIMEO_PATTERN)
	if (vimeoMatch) return { provider: 'vimeo', providerId: vimeoMatch[1] }

	for (const pattern of DAILYMOTION_PATTERNS) {
		const match = trimmed.match(pattern)
		if (match) return { provider: 'dailymotion', providerId: match[1] }
	}

	return null
}
